import { render, staticRenderFns } from "./ActivityOpenQuestionItemFooter.vue?vue&type=template&id=84866e12&scoped=true&"
import script from "./ActivityOpenQuestionItemFooter.vue?vue&type=script&lang=js&"
export * from "./ActivityOpenQuestionItemFooter.vue?vue&type=script&lang=js&"
import style0 from "./ActivityOpenQuestionItemFooter.vue?vue&type=style&index=0&id=84866e12&lang=scss&scoped=true&"
import style1 from "./ActivityOpenQuestionItemFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84866e12",
  null
  
)

export default component.exports